export default "__VITE_ASSET__ae513017__"